import { Streamfield } from '@/types';
import Streamfields from '@streamfields/Streamfields';

type TimeRestrictedSnippet = {
  id: number;
  content: Streamfield[];
};

type Props = {
  time_restricted_blocks: TimeRestrictedSnippet[];
};

// Snippets are filtered by publication/retraction date in the backend,
// only currently active ones are delivered.
function TimeRestrictedContent(props: Props) {
  const { time_restricted_blocks } = props;

  if (!time_restricted_blocks?.length) return null;

  return (
    <>
      {time_restricted_blocks.map(snippet => (
        <Streamfields key={snippet.id} fields={snippet.content} />
      ))}
    </>
  );
}

export default TimeRestrictedContent;
